import React, { useState, useEffect } from 'react';

const BACKEND = '/api';

const CATEGORIES = {
  food: '🍔 Food', retail: '🛍️ Retail', services: '⚙️ Services',
  health: '💊 Health', tech: '💻 Tech', education: '📚 Education',
  travel: '✈️ Travel', other: '📦 Other'
};

export default function MerchantAdmin({ user }) {
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('pending');
  const [selected, setSelected] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchMerchants(); }, [status]);

  const fetchMerchants = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const r = await fetch(`${BACKEND}/merchants/admin/list/?status=${status}`, {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d = await r.json();
      setMerchants(d.merchants || []);
    } catch(e) {}
    setLoading(false);
  };

  const doAction = async (id, action) => {
    try {
      const token = localStorage.getItem('token');
      const r = await fetch(`${BACKEND}/merchants/admin/action/${id}/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
        body: JSON.stringify({ action })
      });
      const d = await r.json();
      if (d.success) {
        setMsg('✅ ' + d.message);
        setSelected(null);
        fetchMerchants();
      }
    } catch(e) { setMsg('❌ Error'); }
  };

  if (!user?.is_staff && !user?.is_superuser) {
    return <div style={{ padding: 40, textAlign: 'center', color: '#ef4444' }}>❌ Unauthorized</div>;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#1a1a2e', borderBottom: '1px solid #2a2a4a', padding: '16px 20px' }}>
        <h2 style={{ color: '#0F6E56', margin: 0 }}>🏪 Merchant Applications</h2>
      </div>

      <div style={{ maxWidth: 1000, margin: '0 auto', padding: 20 }}>
        {msg && <div style={{ background: '#0d2a1a', border: '1px solid #22c55e', borderRadius: 8, padding: 12, marginBottom: 16, color: '#22c55e' }}>{msg}</div>}

        {/* Status Tabs */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {['pending', 'approved', 'rejected'].map(s => (
            <button key={s} onClick={() => setStatus(s)}
              style={{ padding: '8px 20px', background: status === s ? '#0F6E56' : '#1a1a2e', color: status === s ? '#000' : '#aaa', border: '1px solid #2a2a4a', borderRadius: 8, cursor: 'pointer', fontWeight: status === s ? 'bold' : 'normal', textTransform: 'capitalize' }}>
              {s === 'pending' ? '⏳' : s === 'approved' ? '✅' : '❌'} {s}
            </button>
          ))}
          <span style={{ marginLeft: 'auto', color: '#aaa', alignSelf: 'center' }}>{merchants.length} merchants</span>
        </div>

        {/* Merchant List */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>⏳ Loading...</div>
        ) : merchants.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
            <div style={{ fontSize: 48 }}>🌍</div>
            <p>No {status} merchants</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {merchants.map(m => (
              <div key={m.id} style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 12, padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                      <h3 style={{ margin: 0, color: '#fff', fontSize: 16 }}>{m.business_name}</h3>
                      {m.is_verified && <span style={{ background: '#22c55e', color: '#000', fontSize: 10, padding: '2px 6px', borderRadius: 10, fontWeight: 'bold' }}>✓ Verified</span>}
                    </div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
                      <span style={{ color: '#aaa', fontSize: 13 }}>👤 @{m.user}</span>
                      <span style={{ color: '#aaa', fontSize: 13 }}>🥧 @{m.pi_username}</span>
                      <span style={{ color: '#0F6E56', fontSize: 13 }}>{CATEGORIES[m.category] || m.category}</span>
                      {m.city && <span style={{ color: '#aaa', fontSize: 13 }}>📍 {m.city}, {m.country}</span>}
                      {m.pi_discount > 0 && <span style={{ color: '#22c55e', fontSize: 13 }}>🎁 {m.pi_discount}% off</span>}
                    </div>
                    {m.description && <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 4px' }}>{m.description.substring(0, 100)}...</p>}
                    <span style={{ color: '#555', fontSize: 11 }}>Applied: {m.created_at}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button onClick={() => setSelected(m)}
                      style={{ padding: '6px 14px', background: '#0d1b2a', color: '#fff', border: '1px solid #2a2a4a', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
                      👁️ View
                    </button>
                    {status === 'pending' && (
                      <>
                        <button onClick={() => doAction(m.id, 'approve')}
                          style={{ padding: '6px 14px', background: '#22c55e', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 'bold' }}>
                          ✅ Approve
                        </button>
                        <button onClick={() => doAction(m.id, 'reject')}
                          style={{ padding: '6px 14px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 'bold' }}>
                          ❌ Reject
                        </button>
                      </>
                    )}
                    {status === 'approved' && !m.is_verified && (
                      <button onClick={() => doAction(m.id, 'verify')}
                        style={{ padding: '6px 14px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 'bold' }}>
                        ✓ Verify
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Detail Modal */}
      {selected && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 24, maxWidth: 500, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h3 style={{ margin: 0, color: '#0F6E56' }}>{selected.business_name}</h3>
              <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ display: 'grid', gap: 8 }}>
              <p style={{ color: '#aaa', margin: 0 }}>👤 User: @{selected.user}</p>
              <p style={{ color: '#aaa', margin: 0 }}>🥧 Pi: @{selected.pi_username}</p>
              <p style={{ color: '#aaa', margin: 0 }}>📍 {selected.city}, {selected.country}</p>
              {selected.phone && <p style={{ color: '#aaa', margin: 0 }}>📞 {selected.phone}</p>}
              {selected.email && <p style={{ color: '#aaa', margin: 0 }}>✉️ {selected.email}</p>}
              {selected.description && <p style={{ color: '#aaa', margin: 0, fontSize: 13 }}>{selected.description}</p>}
              <p style={{ color: '#aaa', margin: 0 }}>🎁 Discount: {selected.pi_discount}%</p>
              <p style={{ color: '#555', margin: 0, fontSize: 12 }}>Applied: {selected.created_at}</p>
            </div>
            {selected.status === 'pending' && (
              <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                <button onClick={() => doAction(selected.id, 'approve')}
                  style={{ flex: 1, padding: 12, background: '#22c55e', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>
                  ✅ Approve
                </button>
                <button onClick={() => doAction(selected.id, 'reject')}
                  style={{ flex: 1, padding: 12, background: '#ef4444', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>
                  ❌ Reject
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
